import {css} from 'lit';

export default css`
  ::selection {
    background: var(--brand);
    color: var(--brand-text);
  }

  ::slotted(*) {
    display: none;
  }

  ::slotted(ui-searchtip) {
    display: block;
    width: 100%;
    margin-bottom: 1rem;
    background-color: var(--identity-lowVisibility);
    height: 3rem;
    padding: 0;
  }

  ::slotted(ui-searchtip:last-of-type) {
    margin-bottom: 0;
  }
`;

export const searchTipStyle = css`
::slotted(span) {
  height: 3rem;
  padding: 0 1rem;
  display: inline-block;
  cursor: pointer;
  background-color: var(--identity-highVisibility);
  font-family: var(--font-family-sans-serif);
  font-weight: var(--searchbartool-font-weight);
  font-size: var(--searchbartool-font-size);
  line-height: 3rem;
  box-sizing: border-box;
  color: var(--identity-onHighVisibility);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::slotted(span.top:hover) {
  text-decoration: var(--searchbartool-text-decoration);
  background: var(--identity-hover-highVisibility);
}

::slotted(span.top.top1) {
  width: 90%;
}

::slotted(span.top.top2) {
  width: 85%;
}

::slotted(span.top.top3) {
  width: 80%;
}

::slotted(span.top.top4) {
  width: 70%;
}

::slotted(span.top.top5) {
  width: 60%;
}
`;
